import { MemberClass } from '~/api/utils/memberClass'

export type TRatePlanByIdRequestData = {
  ratePlanId: number
  version?: number
}

export const RatePlanBenefitListType = {
  EARLY_CHECK_IN: 'EARLY_CHECK_IN',
  EARLY_CHECK_OUT: 'EARLY_CHECK_OUT',
  FREE_BREAKFAST: 'FREE_BREAKFAST',
  FREE_BREAKFAST_NUMBER: 'FREE_BREAKFAST_NUMBER',
  LATE_CHECK_IN: 'LATE_CHECK_IN',
  LATE_CHECK_OUT: 'LATE_CHECK_OUT',
}

export type TRatePlanBenefitListType =
  (typeof RatePlanBenefitListType)[keyof typeof RatePlanBenefitListType]

export type TRatePlanByIdResponseData = {
  id?: number
  version?: number
  title: string
  propertyId?: string
  roomTypeId?: number
  ruleSetId?: number
  contractMasterId?: number
  contractId?: number
  useType?: string
  ratePlanStatus?: string
  deleted?: boolean
  propertyOnService?: boolean
  roomTypeOnService?: boolean
  fitForReservationPolicy?: boolean
  onService?: boolean
  startDate?: string
  endDate?: string
  checkInStartDate?: string
  checkInEndDate?: string
  saleStartTime?: string
  saleEndTime?: string
  afterMidnightCheckIn?: boolean
  todaySaleClosingTime?: string
  usableCoupon?: boolean
  earnablePoint?: boolean
  confirmedReservation?: boolean
  parkingAvailability?: boolean
  capacity?: number
  maxCapacity?: number
  minNights?: number
  maxNights?: number
  minDaysInAdvance?: number
  maxDaysInAdvance?: number
  cancelPolicy?: number
  fixedDiscount?: number
  amenityList?: number[]
  surchargeList?: number[]
  productTypeList?: string[]
  agePolicy?: {
    child?: number
    toddler?: number
  }
  benefitList: {
    type: TRatePlanBenefitListType
    name: string
    value: string
  }[]
  extraPersonCharge?: {
    adultRate?: number
    childRate?: number
    toddlerRate?: number
  }
  channelId?: number
  channelOut?: boolean
  salesOta?: string[]
  description?: string
  createdAt?: string
  updatedAt?: string
  memberClass?: MemberClass
  sharedRatePlans?: {
    ratePlanId?: number
    memberClass?: MemberClass
  }[]
  originalRatePlanId?: number
  discountRate?: number
}

type TRatePlanUseType = 'dayuse' | 'overnight'

export type TAvailableInventoryByRoomTypeIdRequestData = {
  roomTypeId: number
  useType: TRatePlanUseType
  checkInDate: string
  checkOutDate: string
  checkInTime?: string
  persons?: {
    adultPax: number
    childAges?: number[]
  }
}

export type TInventoryRatePlanItemDate = {
  date: string
  rackRate: number
  rate: number
  extraPersonRate: number
  otherSettings?: {
    depositPrice?: number
  }
}

export type TInventoryRatePlanItem = {
  totalOriginalRate: number
  ratePlanId: number
  ratePlanVersion?: number
  ratePlanStatus: string
  availability: 'VALID' | 'INVALID'
  checkInTime?: string
  checkOutTime?: string
  useTime?: number // 대실 이용 시간
  invalidReason: string
  totalRackRate: number
  totalRate: number
  cancelPolicy: number // 취소수수료 id
  adsList: number[]
  dates: TInventoryRatePlanItemDate[]
}

export type TAvailableInventoryByRoomTypeIdResponseData = {
  inventory: {
    ratePlans: TInventoryRatePlanItem[]
  }[]
}

export type TAvailableInventoryByRatePlanIdRequestData = {
  ratePlanId: number
  version?: number
  useType?: TRatePlanUseType
  checkInDate: string // yyyy-MM-dd
  checkOutDate: string // yyyy-MM-dd
  checkInTime?: string // HH:mm
  persons?: {
    adultPax: number
    childAges?: number[]
  }
  surcharges?: number[]
}

type TInventory = {
  totalOriginalRate: number
  ratePlanId: number
  ratePlanVersion?: number
  ratePlanStatus: string
  availability: 'VALID' | 'INVALID'
  checkInTime?: string
  checkOutTime?: string
  useTime?: number // 대실 이용 시간
  invalidReason: string
  totalRackRate: number
  totalRate: number
  cancelPolicy: number // 취소수수료 id
  adsList: number[]
  lastCheckInTime?: string
  dates: TInventoryRatePlanItemDate[]
}

export type TAvailableInventoryByRatePlanIdResponse = {
  inventory: TInventory
}

export type TAvailableInventoryByRatePlanIdResponseData = TInventory & {
  checkInTime?: string
  checkOutTime?: string
  price?: number
}
